/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener('DOMContentLoaded', () => {
	const tableRows = document.querySelectorAll('.wpce-course-table tbody tr');
	const daySelect = document.getElementById('filter-day');
	const trainerSelect = document.getElementById('filter-trainer');
	const locationSelect = document.getElementById('filter-location');
	const sectionSelect = document.getElementById('filter-section');
	const resetBtn = document.getElementById('filter-reset');
	const toggleBtn = document.querySelector('.wpce-filter-toggle');
	const filterWrapper = document.querySelector('.wpce-course-filter');

	// Filter anwenden
	function applyFilters() {
		const day = daySelect?.value || '';
		const trainer = trainerSelect?.value || '';
		const location = locationSelect?.value || '';
		const section = sectionSelect?.value || '';

		tableRows.forEach((row) => {
			const matchesDay = !day || row.dataset.day === day;
			const matchesTrainer =
				!trainer || row.dataset.trainer.includes(trainer);
			const matchesLocation =
				!location || row.dataset.location === location;
			const matchesSection =
				!section || row.dataset.section.includes(section);

			row.style.display =
				matchesDay &&
				matchesTrainer &&
				matchesLocation &&
				matchesSection
					? ''
					: 'none';
		});
	}

	// Filter zurücksetzen
	function resetFilters() {
		if (daySelect) daySelect.value = '';
		if (trainerSelect) trainerSelect.value = '';
		if (locationSelect) locationSelect.value = '';
		if (sectionSelect) sectionSelect.value = '';

		applyFilters();
	}

	// Event-Listener für Filteränderung
	daySelect?.addEventListener('change', applyFilters);
	trainerSelect?.addEventListener('change', applyFilters);
	sectionSelect?.addEventListener('change', applyFilters);
	locationSelect?.addEventListener('change', applyFilters);
	resetBtn?.addEventListener('click', resetFilters);

	// Toggle sichtbar/unsichtbar mit Reset beim Zuklappen
	toggleBtn?.addEventListener('click', () => {
		const isOpen = filterWrapper.classList.toggle('open');
		if (!isOpen) {
			resetFilters();
		}
	});

	// Sortierung
	const table = document.querySelector('.wpce-course-table');
	if (!table) return;

	const tbody = table.querySelector('tbody');
	const headers = table.querySelectorAll('th');

	const weekdayOrder = {
		montag: 1,
		dienstag: 2,
		mittwoch: 3,
		donnerstag: 4,
		freitag: 5,
		samstag: 6,
		sonntag: 7,
	};

	function getWeekdayOrder(text) {
		for (const key of Object.keys(weekdayOrder)) {
			if (text.toLowerCase().includes(key)) {
				return weekdayOrder[key];
			}
		}
		return 99;
	}

	const sortStates = {};

	function sortTable(colIndex, initial = false) {
		const rows = Array.from(tbody.querySelectorAll('tr'));
		const th = headers[colIndex];

		// toggle zustand
		if (sortStates[colIndex] === undefined) {
			sortStates[colIndex] = true; // standard aufsteigend
		} else if (!initial) {
			sortStates[colIndex] = !sortStates[colIndex];
		}

		const ascending = sortStates[colIndex];

		// alle pfeile zurücksetzen
		headers.forEach((h) => {
			h.classList.remove('sorted-asc', 'sorted-desc');
		});

		th.classList.add(ascending ? 'sorted-asc' : 'sorted-desc');

		rows.sort((a, b) => {
			const aText = a.children[colIndex].textContent.trim().toLowerCase();
			const bText = b.children[colIndex].textContent.trim().toLowerCase();

			if (colIndex === 0) {
				const aDay = getWeekdayOrder(aText);
				const bDay = getWeekdayOrder(bText);
				if (aDay !== bDay) return ascending ? aDay - bDay : bDay - aDay;
			}

			if (aText < bText) return ascending ? -1 : 1;
			if (aText > bText) return ascending ? 1 : -1;
			return 0;
		});

		rows.forEach((row) => tbody.appendChild(row));
	}

	// standardmäßig Zeit sortieren
	sortTable(0, true);

	headers.forEach((th, idx) => {
		th.style.cursor = 'pointer';
		th.addEventListener('click', () => {
			sortTable(idx);
		});
	});
});
